import styled from 'styled-components';

export const Styledform = styled.form`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;
